
export { default as DatadogRumScript } from "./datadog/DatadogRumScript"